import { render, staticRenderFns } from "./VsSelect.vue?vue&type=template&id=5bab1c00&lang=pug&"
import script from "./VsSelect.vue?vue&type=script&lang=js&"
export * from "./VsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bab1c00')) {
      api.createRecord('5bab1c00', component.options)
    } else {
      api.reload('5bab1c00', component.options)
    }
    module.hot.accept("./VsSelect.vue?vue&type=template&id=5bab1c00&lang=pug&", function () {
      api.rerender('5bab1c00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/viralstyle-ui/src/VsSelect.vue"
export default component.exports